import { useState } from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useTheme } from '../hooks/useTheme';
import './Layout.css';

const NAV = [
  { to: '/receipts', label: 'Receipts' },
  { to: '/upload', label: 'Upload' },
  { to: '/stores', label: 'Stores' },
  { to: '/trends', label: 'Price Trends' },
  { to: '/compare', label: 'Store Comparison' },
  { to: '/inflation', label: 'Inflation' },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="app-shell">
      {/* Mobile top bar */}
      <div className="topbar">
        <button
          className="hamburger-btn"
          onClick={() => setMenuOpen((o) => !o)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          {menuOpen ? '✕' : '☰'}
        </button>
        <span className="topbar-title">PriceTracker</span>
      </div>

      {/* Backdrop for off-canvas sidebar on mobile */}
      <div
        className={`sidebar-backdrop${menuOpen ? ' open' : ''}`}
        onClick={closeMenu}
      />

      {/* Sidebar */}
      <nav className={`sidebar${menuOpen ? ' open' : ''}`}>
        <div className="sidebar-brand">PriceTracker</div>
        {NAV.map(({ to, label }) => (
          <NavLink
            key={to}
            to={to}
            onClick={closeMenu}
            className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
          >
            {label}
          </NavLink>
        ))}
        <NavLink
          to="/account/security"
          onClick={closeMenu}
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          Account security
        </NavLink>
        {user?.isAdmin && (
          <>
            <NavLink
              to="/admin/settings"
              onClick={closeMenu}
              className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
            >
              Admin settings
            </NavLink>
            <NavLink
              to="/admin/users"
              onClick={closeMenu}
              className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
            >
              Admin users
            </NavLink>
          </>
        )}
        <div className="sidebar-spacer" />
        <div className="sidebar-footer">
          <div>{user?.email}</div>
          <button
            className="sidebar-theme-toggle"
            onClick={toggleTheme}
            aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {theme === 'dark' ? '☀️ Light mode' : '🌙 Dark mode'}
          </button>
          <button className="sidebar-signout" onClick={logout}>
            Sign out
          </button>
        </div>
      </nav>

      {/* Main */}
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
